import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SectionTitle from "@/components/feature/SectionTitle";
import SkeletonCard from "@/components/feature/SkeletonCard";
import NewsCard from "@/components/feature/NewsCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";
import HotRanking from "@/pages/home/components/HotRanking";
import SpecialPicks from "@/pages/home/components/SpecialPicks";
import { getLatestNews, getHotNews, specials } from "@/utils/news";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const id = window.setTimeout(() => setLoading(false), 700);
    return () => window.clearTimeout(id);
  }, []);

  const focusNews = getLatestNews(4);
  const latestNews = getLatestNews(8);
  const hotNews = getHotNews(8);
  const specialPicks = specials.slice(0, 3);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="w-full px-4 md:px-8 py-6">
        <HeroCarousel items={focusNews} />

        <section className="mt-8">
          <SectionTitle title="分类快捷入口" subtitle="挑一个感兴趣的方向，快速进入浏览" icon="ri-apps-2-line" />
          <CategoryQuickEntry />
        </section>

        <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <SectionTitle
              title="最新新闻"
              subtitle="按发布时间倒序更新，爆料不迟到"
              icon="ri-time-line"
              action={
                <Link
                  to="/search"
                  className="text-sm text-primary-600 whitespace-nowrap inline-flex items-center gap-1 hover:text-primary-700 cursor-pointer"
                >
                  查看全部 <i className="ri-arrow-right-line" />
                </Link>
              }
            />
            <div className="flex flex-col gap-3">
              {loading ? (
                Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)
              ) : latestNews.length > 0 ? (
                latestNews.map((item) => <NewsCard key={item.id} item={item} />)
              ) : (
                <div className="py-16 text-center text-foreground-500 rounded-lg bg-background-100">暂无最新新闻</div>
              )}
            </div>
          </div>

          <aside className="lg:col-span-1">
            <SectionTitle title="热门新闻排行" subtitle="近期最受关注的内容" icon="ri-fire-line" />
            <HotRanking items={hotNews} />
          </aside>
        </section>

        <section className="mt-10">
          <SectionTitle title="精选专题推荐" subtitle="把热点串成线，看清事件的来龙去脉" icon="ri-book-2-line" />
          <SpecialPicks items={specialPicks} />
        </section>

        <section className="mt-10 rounded-lg bg-secondary-100 border border-secondary-200 p-6 md:p-10">
          <h1 className="text-xl md:text-3xl font-black text-secondary-950 leading-snug">
            {siteInfo.name} · 最新娱乐八卦与社会新闻热点大全
          </h1>
          <p className="text-sm md:text-base text-secondary-800 mt-4 leading-relaxed max-w-3xl">{siteInfo.description}</p>
          <div className="flex flex-wrap items-center gap-6 mt-6">
            {[
              { icon: "ri-newspaper-line", label: "实时爆料" },
              { icon: "ri-layout-grid-line", label: "多维分类" },
              { icon: "ri-search-eye-line", label: "关键词搜索" },
              { icon: "ri-device-line", label: "多端适配" },
            ].map((f) => (
              <div key={f.label} className="flex items-center gap-2 text-sm text-secondary-900">
                <span className="w-8 h-8 rounded-md bg-background-50 flex items-center justify-center text-primary-600">
                  <i className={f.icon} />
                </span>
                {f.label}
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}